export const businessDayTypeEnum = {
  dayOff: 'dayOff',
  workingDay: 'workingDay'
};

export const businessDayTypes = {
  dayOff: 'Выходной',
  workingDay: 'Рабочий день'
};
